<script>
export default {
    name: 'CrmMenu',
};
</script>

<template>
    <ul class="nav nav-tabs nav-tabs-bottom bg-white mb-0">
        <li class="nav-item ml-2"><router-link :to="{ name: 'crm.todos' }" class="nav-link" active-class="active">Att göra</router-link></li>
        <li class="nav-item"><router-link :to="{ name: 'crm.companies' }" class="nav-link" active-class="active">Företag</router-link></li>
        <li class="nav-item"><router-link :to="{ name: 'crm.contacts' }" class="nav-link" active-class="active">Kontakter</router-link></li>
    </ul>
</template>
